import { useState } from 'react';
import { Send, Lock, Globe } from 'lucide-react';

interface CommentFormProps {
  onSubmit: (content: string, isPrivate: boolean) => void;
  loading?: boolean;
  placeholder?: string;
}

export default function CommentForm({
  onSubmit,
  loading = false,
  placeholder = '댓글을 작성하세요...',
}: CommentFormProps) {
  const [content, setContent] = useState('');
  const [isPrivate, setIsPrivate] = useState(false);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();

    if (!content.trim()) {
      return;
    }

    onSubmit(content.trim(), isPrivate);
    setContent('');
    setIsPrivate(false);
  };

  return (
    <form onSubmit={handleSubmit} className="bg-white rounded-lg border border-gray-200 p-4">
      <textarea
        value={content}
        onChange={(e) => setContent(e.target.value)}
        placeholder={placeholder}
        rows={4}
        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-primary resize-none text-sm"
        disabled={loading}
      />

      <div className="mt-3 flex items-center justify-between">
        {/* 비공개 토글 */}
        <div className="flex items-center gap-2">
          <button
            type="button"
            onClick={() => setIsPrivate(!isPrivate)}
            className={`flex items-center gap-2 px-3 py-1.5 rounded-lg text-sm font-medium transition-colors ${
              isPrivate
                ? 'bg-gray-100 text-gray-700 border border-gray-300'
                : 'bg-gray-50 text-gray-600 hover:bg-gray-100'
            }`}
          >
            {isPrivate ? (
              <>
                <Lock className="w-4 h-4" />
                비공개
              </>
            ) : (
              <>
                <Globe className="w-4 h-4" />
                공개
              </>
            )}
          </button>
          {isPrivate && (
            <span className="text-xs text-gray-500">
              작성자와 수업 업체만 볼 수 있습니다
            </span>
          )}
        </div>

        {/* 제출 버튼 */}
        <button
          type="submit"
          disabled={!content.trim() || loading}
          className="px-4 py-2 bg-primary text-white rounded-lg hover:bg-primary-600 transition-colors disabled:opacity-50 disabled:cursor-not-allowed flex items-center gap-2 text-sm font-medium"
        >
          {loading ? (
            <>
              <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white" />
              작성 중...
            </>
          ) : (
            <>
              <Send className="w-4 h-4" />
              댓글 작성
            </>
          )}
        </button>
      </div>
    </form>
  );
}
